// @ts-nocheck
import React, { memo } from 'react';
import { Grid } from '@material-ui/core';
import { Form, Formik, FormikHelpers } from 'formik';

import Button from '../../elements/Button';
import { BUTTON_COLOR, BUTTON_SIZE, BUTTON_TYPE, BUTTON_VARIANT } from '../../enum/formProps';
import { ENTITY_ACTIONS } from './enum/entityActions';

import './EntityForm.scss';

interface EntityFormProps<T> {
  initialValues: T;
  validationSchema: object;
  onSubmit: (values: T, formikHelpers?: FormikHelpers<T>, actionType?: ENTITY_ACTIONS) => void;
  disabled?: boolean;
  enablePreview?: boolean;
}

function component<T>(props: React.PropsWithChildren<EntityFormProps<T>>) {
  let actionsType = ENTITY_ACTIONS.SAVE;

  return (
    <Formik
      initialValues={props.initialValues}
      onSubmit={(values, formikHelpers) => {
        props.onSubmit(values, formikHelpers, actionsType);
      }}
      validationSchema={props.validationSchema}
      enableReinitialize={true}
      validateOnChange={false}
    >
      <Form noValidate className="EntityForm-Wrapper">
        {props.children}
        <Grid container spacing={0} className="EntityForm-Container">
          <Grid item xs={4} md={3} lg={2} xl={1}></Grid>
          <Grid item xs={8} md={9} lg={10} xl={11}>
            <Button
              className="button-save"
              text="button.save"
              size={BUTTON_SIZE.LARGE}
              color={BUTTON_COLOR.PRIMARY}
              variant={BUTTON_VARIANT.CONTAINED}
              type={BUTTON_TYPE.SUBMIT}
              disabled={props.disabled}
              onClick={() => {
                actionsType = ENTITY_ACTIONS.SAVE;
              }}
            />

            {props.enablePreview && (
              <Button
                className="button-preview"
                text="button.preview"
                size={BUTTON_SIZE.LARGE}
                color={BUTTON_COLOR.DEFAULT}
                variant={BUTTON_VARIANT.CONTAINED}
                type={BUTTON_TYPE.SUBMIT}
                disabled={props.disabled}
                onClick={() => {
                  actionsType = ENTITY_ACTIONS.PREVIEW;
                }}
              />
            )}
          </Grid>
        </Grid>
      </Form>
    </Formik>
  );
}

const EntityForm = memo(component) as typeof component;

export default EntityForm;
